// External imports
import BlueLogo from '../assets/brand/logo.png';

// Bootstrap components
import { Navbar, Container, NavbarBrand } from 'reactstrap';

const Navigation = () => {
	return (
		<Navbar className="navbar-horizontal navbar-dark bg-success" expand="md" >
			<Container>
				<NavbarBrand href="/">
					<img className="img-fluid" src={BlueLogo} alt="Food Recipe Logo" style={{width: "250px", height: "50px"}} />
				</NavbarBrand>
			</Container>
		</Navbar>
	)
}

export default Navigation
